import { useTranslation } from 'react-i18next'
import { BreadcrumbProps } from 'src/components/Breadcrumb'
import { Article } from 'src/rest/types/Article'
import { Engagement } from 'src/rest/types/Engagement'
import { Job } from 'src/rest/types/Job'
import { Page } from 'src/rest/types/Page'
import { Project } from 'src/rest/types/Project'
import { Talent } from 'src/rest/types/Talent'
import routes from 'src/routes/definitions'

const useBreadcrumb = ({
  page,
}: {
  page: Page | Project | Talent | Engagement | Job | Article
}): BreadcrumbProps => {
  const { t } = useTranslation()
  return {
    links: [
      { text: t('breadcrumb.home'), href: routes.home.path },
      {
        text:
          (page as any)?.pageTitle ||
          (page as any)?.title ||
          (page as any).name ||
          '',
      },
    ],
  }
}

export default useBreadcrumb
